import React, { useEffect, useRef } from "react";
import "./gateawayfeature.scss";
import { Link } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Placeholder } from "react-bootstrap";
gsap.registerPlugin(ScrollTrigger);

const Gateawayfeature = () => {
  const textRefs = useRef([]);
  const paraRefs = useRef([]);
  const buttonRefs = useRef([]);

  useEffect(() => {
    textRefs.current.forEach((text) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: text,
          start: "top 80%",
          toggleActions: "play none none none",
        },
      });

      gsap.set(text, {
        clipPath: "inset(0% 100% 0% 0%)",
        opacity: 1,
      });

      tl.to(text, {
        clipPath: "inset(0% 0% 0% 0%)",
        duration: 1,
        ease: "power2.out",
      });
    });
  }, []);

  useEffect(() => {
    paraRefs.current.forEach((para) => {
      gsap.fromTo(
        para,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: para,
            start: "top 90%",
            toggleActions: "play none none none",
          },
        }
      );
    });
  }, []);

  useEffect(() => {
    buttonRefs.current.forEach((button) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: button,
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      gsap.set(button, {
        clipPath: "inset(0% 100% 0% 0%)",
        opacity: 1,
      });

      tl.to(button, {
        clipPath: "inset(0% 0% 0% 0%)",
        duration: 0.5,
        ease: "power2.out",
      }).to(button, {
        rotateY: 360,
        duration: 0.8,
        ease: "power2.inOut",
      });
    });
  }, []);
  return (
    <section className="gateawayfeatureprnt">
      <div className="custom-container">
        <div className="contentgateaway">
          <div className="firstcardgateaway">
            <div className="gateawayimg">
              <img
                className="img-fluid"
                src="/assets/firstcardfeatureimg.png"
                alt="secure Communication & Payments img"
              />
              <div className="mainmobile">
                <video
                  className="innervideo"
                  muted="muted"
                  playsinline="playsinline"
                  autoPlay
                  loop
                  width="100%"
                  id="myVideo"
                >
                  <source src="\assets\featuretwo.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
            <div className="leftcntgateaway">
              <h6 ref={(el) => (buttonRefs.current[0] = el)}>01</h6>
              <h2 ref={(el) => (textRefs.current[0] = el)}>
                Secure Communication & Payments
              </h2>
              <p ref={(el) => (paraRefs.current[0] = el)}>
                Send messages and crypto as easily as texting. Create private
                groups with integrated payment features.
              </p>
              <Link
                to="/chatandpay"
                className="leftcntgateawaybtn secondarybtn"
              >
                Learn More
              </Link>
            </div>
          </div>
          <div className="firstcardgateaway firstcardgateawayreverse ">
            <div className="leftcntgateaway">
              <h6 ref={(el) => (buttonRefs.current[1] = el)}>Future Release</h6>
              <h2 ref={(el) => (textRefs.current[1] = el)}>
                Decentralized Groups
              </h2>
              <p ref={(el) => (paraRefs.current[1] = el)}>
                Create and manage communities with advanced privacy and
                monetization.
              </p>
              <Link
                to="/buildgroup"
                className="leftcntgateawaybtn secondarybtn"
              >
                Learn More
              </Link>
            </div>
            <div className="gateawayimg">
              <img
                className="img-fluid"
                src="/assets/firstcardfeatureimg2.png"
                alt="Decentralized Groups Img"
              />
                <div className="mainmobile">
             
              <video className="innervideo"
                    muted="muted" playsinline="playsinline"
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo">
                    <source src="\assets\featurethreenew.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
          <div className="firstcardgateaway">
            <div className="gateawayimg">
            <div className="mainmobile">
              <video className="innervideo"
                    muted="muted" playsinline="playsinline"
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo">
                    <source src="\assets\featurefournew.mp4" type="video/mp4" />
                </video>
              </div>
              <img
                className="img-fluid"
                src="/assets/firstcardfeatureimg3.png"
                alt="Multi-Profile System img"
              />
            </div>
            <div className="leftcntgateaway">
              <h6 ref={(el) => (buttonRefs.current[2] = el)}>Future Release</h6>
              <h2 ref={(el) => (textRefs.current[2] = el)}>
                {" "}
                Multi-Profile System{" "}
              </h2>
              <p ref={(el) => (paraRefs.current[2] = el)}>
                Manage multiple identities with varying privacy levels.
              </p>
              <Link
                to="/createprofile"
                className="leftcntgateawaybtn secondarybtn"
              >
                Learn More
              </Link>
            </div>
          </div>
          <div className="firstcardgateaway firstcardgateawayreverse">
            <div className="leftcntgateaway">
              <h6 ref={(el) => (buttonRefs.current[3] = el)}>Future Release</h6>
              <h2 ref={(el) => (textRefs.current[3] = el)}>
                Secure Browser & VPN{" "}
              </h2>
              <p ref={(el) => (paraRefs.current[3] = el)}>
                Built-in VPN and ad-blocking for private Web2 and Web3 browsing.
              </p>
              <Link
                to="/browsesecurely"
                className="leftcntgateawaybtn secondarybtn"
              >
                Learn More
              </Link>
            </div>
            <div className="gateawayimg">
              <img
                className="img-fluid"
                src="/assets/firstcardfeatureimg4.png"
                alt="Secure Browser & VPN img"
              />
                 <div className="mainmobile">
              <video className="innervideo"
                    muted="muted" playsinline="playsinline"
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo">
                    <source src="\assets\featurefivenew.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gateawayfeature;
